var DialogLocationsGroupsModule = /** @class */ (function () {
    function DialogLocationsGroupsModule() {
    }
    return DialogLocationsGroupsModule;
}());
export { DialogLocationsGroupsModule };
